module.exports = {
	"id": "SV",
	"name": "El Salvador",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.017895,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.01193,
			"22": 0.04772,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01193,
			"27": 0.005965,
			"28": 0.005965,
			"29": 0.01193,
			"30": null,
			"31": 0.029825,
			"32": 0.01193,
			"33": 0.01193,
			"34": 0.029825,
			"35": 0.029825,
			"36": 0.029825,
			"37": 0.053685,
			"38": 0.041755,
			"39": 0.065615,
			"40": 0.041755,
			"41": 0.017895,
			"42": 0.03579,
			"43": 0.15509,
			"44": 0.07158,
			"45": 0.04772,
			"46": 0.077545,
			"47": 0.36983,
			"48": 0.089475,
			"49": 2.201085,
			"50": 0.15509,
			"51": 0.48913,
			"52": 0.50106,
			"53": 28.07129,
			"54": 7.59941,
			"55": 0.053685,
			"56": 0.005965,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.089475,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.005965,
			"11": null,
			"12": 0.005965,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005965,
			"17": 0.005965,
			"18": null,
			"19": null,
			"20": 0.017895,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.01193,
			"25": null,
			"26": 0.01193,
			"27": 0.01193,
			"28": 0.01193,
			"29": 0.01193,
			"30": 0.01193,
			"31": 0.029825,
			"32": null,
			"33": 0.017895,
			"34": 0.005965,
			"35": 0.029825,
			"36": 0.02386,
			"37": 0.02386,
			"38": 0.041755,
			"39": 0.053685,
			"40": 0.04772,
			"41": 0.08351,
			"42": 0.029825,
			"43": 0.16702,
			"44": 0.041755,
			"45": 0.21474,
			"46": 0.09544,
			"47": 0.40562,
			"48": 0.54878,
			"49": 5.374465,
			"50": 0.07158,
			"51": 0.01193,
			"52": null,
			"3.5": 0.005965,
			"3.6": 0.02386
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.01193,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.017895,
			"37": 0.07158,
			"38": 0.02386,
			"39": 0.01193,
			"40": 0.530885,
			"41": 0.077545,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01193
		},
		"safari": {
			"0": null,
			"4": 0.01193,
			"5": 0.04772,
			"6": null,
			"7": 0.01193,
			"8": 0.208775,
			"9": 0.14316,
			"10": 0.745625,
			"3.1": null,
			"3.2": null,
			"5.1": 0.029825,
			"6.1": 0.017895,
			"7.1": 0.01193,
			"9.1": 0.626325
		},
		"ios_saf": {
			"8": 0,
			"10": 1.77911246878,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0479450223772,
			"8.1-8.4": 0.0885763972731,
			"9.0-9.2": 0.0422566298918,
			"9.3": 0.644684481682
		},
		"android": {
			"3": 0,
			"4": 0.11560744186,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0144509302326,
			"4.1": 0.41701255814,
			"4.2-4.3": 1.04253139535,
			"4.4": 2.39059674419,
			"4.4.3-4.4.4": 2.41124093023
		},
		"ie": {
			"6": null,
			"7": 0.00598725746269,
			"8": 0.233503041045,
			"9": 0.107770634328,
			"10": 0.131719664179,
			"11": 1.12560440299,
			"5.5": null
		},
		"op_mob": {
			"0": 0.175306492317,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00486962478657
		},
		"edge": {
			"12": 0.089475,
			"13": 0.268425,
			"14": 0.435445
		},
		"ie_mob": {
			"10": 0.106614929577,
			"11": 0.434075070423
		},
		"bb": {
			"7": 0.04842,
			"10": null
		},
		"samsung": {
			"0": 2.069955
		},
		"and_uc": {
			"0": 2.788185
		},
		"op_mini": {
			"0": 2.3618738829
		},
		"and_chr": {
			"0": 28.98801
		},
		"and_ff": {
			"0": 0.01614
		}
	},
	"total": 98.9507
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SV.json
 ** module id = 652
 ** module chunks = 0
 **/